import { useInfiniteQuery } from "@tanstack/react-query";
import apiClient from "lib/api-client";
import { formatOrderDate } from "utils/formatDate";

const getOrderDetails = async ({ queryKey, pageParam = 1 }) => {
  const { limit, orderId } = queryKey;
  const payload = {
    pageNumber: pageParam,
    limit: limit,
  };

  const response = await apiClient.post(`/api/v3/clinet/order/${orderId}`, payload);

  if (response.status !== 200) {
    throw new Error("Error fetching order data");
  }

  return {
    orderData: response.data?.orderData?.orderStyles,
    currentPage: response.data?.paginationData?.currentPage,
    totalPages: response.data?.paginationData?.totalPages,
    totalOrdersCount: response.data?.paginationData?.totalOrdersCount,
    catalog: response.data?.orderData?.catalog,
    client: response.data?.orderData?.client,
    totalGoldGrossWeight: response.data?.orderData?.totalGoldGrossWeight,
    totalGoldNetWeight: response.data?.orderData?.totalGoldNetWeight,
    totalDiaWeight: response.data?.orderData?.totalDiaWeight,
    totalDiaPcs: response.data?.orderData?.totalDiaPcs,
    orderNumber: response.data?.orderData?.orderNumber,
    orderId: response.data?.orderData?.orderId,
    orderDate: formatOrderDate(response.data?.orderData?.orderDate),
  };
};

export const useOrdersDetails = ({ limit = 10, orderId = "67e527341ebd8afb4ced2495" }) => {
  return useInfiniteQuery({
    queryKey: ["orderDetails", { limit, orderId }],
    queryFn: ({ pageParam = 1 }) => getOrderDetails({ queryKey: { limit, orderId }, pageParam }),
    getNextPageParam: (lastPage) => {
      if (lastPage.currentPage < lastPage.totalPages) {
        return lastPage.currentPage + 1;
      }
      return undefined;
    },
    staleTime: 5 * 60 * 1000,
    retry: 1,
  });
};

